<template>
  <div class="scd">
    <c_Nav :Index="Index" :city-code="cityCode"></c_Nav>
    <c_NewMessage></c_NewMessage>
    <!--内容  star-->
    <div class="scdMain">
      <div class="secondMainTitle">
        <i></i>
        <span>新闻中心</span>
      </div>
      <h5>{{newsData.NewsName}}</h5>
      <div class="scdMainText">
        <p></p>
        <div class="smtDate"><span>更新日期：</span><span>{{formatDate('Y-m-d',newsData.CreateTime)}}</span></div>
      </div>

      <div class="prev" v-if="newsData.PreviousID">
        <router-link :to="{path:'/NewsCenterDetail',query:{cityCode:cityCode,id:newsData.PreviousID}}">
          <span>上一篇：</span><span>{{newsData.PreviousName}}</span>
        </router-link>
      </div>
      <div class="prev" v-else>
        <span>上一篇：</span><span>暂无上一篇</span>
      </div>
      <div class="next" v-if="newsData.NextID">
        <router-link :to="{path:'/NewsCenterDetail',query:{cityCode:cityCode,id:newsData.NextID}}">
          <span>下一篇：</span><span>{{newsData.NextName}}</span>
        </router-link>
      </div>
      <div class="next" v-else>
        <span>下一篇：</span><span>暂无下一篇</span>
      </div>
    </div>
    <!--内容  end-->

  </div>
</template>

<script>
  import c_Nav from '@/components/Nav/Nav'
  import c_NewMessage from '@/components/NewMessage/NewMessage'
  export default {
    name: '',
    props:['cityCode'],
    components:{c_Nav,c_NewMessage},
    data () {
      return {
        Index:5,
        newsData:{}
      }
    },
    mounted() {
      this.getNewsDetail();
    },
    watch:{
      '$route'(to,from){
        this.getNewsDetail();
      }
    },
    methods:{
      getNewsDetail:function () {
        var that = this;
        this.axios.get('NewsContent',{
          params:{id:that.$route.query.id}
        }).then(function (res) {
          console.log(res);
          that.newsData = res.data.data;
        }).catch(function (err) {
          console.log(err);
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .clear {overflow: hidden;}
  .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

  .scdMain{width: 702px;margin: 0 auto 120px;}

  /*标题  star*/
  .secondMainTitle{height: 90px;border-bottom: 2px dashed #9fb0c0;text-align: left}
  .secondMainTitle i{width: 8px;height: 36px;background: #1dd2af;display: inline-block;text-align: left;margin-top: 44px;}
  .secondMainTitle span{height:44px;font-size:32px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(44,62,80,1);margin: 0 0 0 14px;display:inline-block}
  /*标题  end*/

  .scdMain h5{font-size:32px;font-family:PingFangSC-Medium;font-weight:600;color: #2c3e50;margin: 40px auto;text-align: center}
  .scdMainText{border-bottom: 2px dashed #9fb0c0}
  .smtDate{font-size:24px;font-family:PingFangSC-Regular;font-weight:400;color: #9fb0c0;margin: 20px 0;text-align: right}

  .prev,.next{height:40px;font-size:28px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(44,62,80,1);line-height:40px;text-align: left;margin-top: 40px;}
  .prev a,.next a{display: block;color: #2c3e50;}
  .next{margin-top: 20px;}

</style>



// WEBPACK FOOTER //
// src/components/NewsCenterDetail/NewsCenterDetail.vue